// Naming Format: OTO_ADMIN_{PageName}_{EventName}
export const ANALYTICS_EVENT = Object.freeze({
  NAVIGATION: {
    // Naming Format: OTO_ADMIN_{EventName}
    OTO_ADMIN_SIDEBAR_NAVIGATE: 'oto_admin_sidebar_navigate',
    OTO_ADMIN_PAGE_VIEW: 'oto_admin_page_view',
  },
  BUTTON: {
    // Naming Format: OTO_ADMIN_{PageName}_{EventName}
    OTO_ADMIN_HOMEPAGE_ACTIVE_VEHICLE_BY_HOURS:
      'oto_admin_homepage_active_vehicle_by_hours',
  },
  API_TIMEOUT: 'oto_dashboard_api_timeout',
})

export const logEvent = (eventName, params = {}) => {
  if (window.firebase?.analytics) {
    window.firebase.analytics().logEvent(eventName, params)
  }
  //   else if (window.gtag) {
  //     window.gtag('event', eventName, params)
  //   }
  else {
    console.warn('Analytics not loaded', eventName, params)
  }
}
